module.exports = __webpack_public_path__ + "static/media/boomea-logo.ed1161e2.svg";